import Vue from 'vue'
import Router from 'vue-router'

import LoginPage from '@/pages/login/LoginPage'

import DashboardPage from '@/pages/dashboard/DashboardPage'

import ProductList from '@/pages/products/ProductList'
import ProductEdit from '@/pages/products/ProductEdit'
import ProductAdd from '@/pages/products/ProductAdd'

import OrderList from '@/pages/orders/OrderList'
import OrderEdit from '@/pages/orders/OrderEdit'
import OrderView from '@/pages/orders/OrderView'

import PrintTypeList from '@/pages/print-types/PrintTypeList'
import PrintTypeEdit from '@/pages/print-types/PrintTypeEdit'
import PrintTypeAdd from '@/pages/print-types/PrintTypeAdd'

import CorporationList from '@/pages/corporations/CorporationList'
import CorporationEdit from '@/pages/corporations/CorporationEdit'
import CorporationAdd from '@/pages/corporations/CorporationAdd'

import SupplierList from '@/pages/suppliers/SupplierList'
import SupplierEdit from '@/pages/suppliers/SupplierEdit'
import SupplierAdd from '@/pages/suppliers/SupplierAdd'

import TaxList from '@/pages/tax/TaxList'
import TaxEdit from '@/pages/tax/TaxEdit'
import TaxAdd from '@/pages/tax/TaxAdd'

import ProductCategoryList from '@/pages/product-categories/ProductCategoryList'
import ProductCategoryEdit from '@/pages/product-categories/ProductCategoryEdit'
import ProductCategoryAdd from '@/pages/product-categories/ProductCategoryAdd'

import UserList from '@/pages/users/UserList'
import UserEdit from '@/pages/users/UserEdit'
import UsersAdd from '@/pages/users/UserAdd'

import TemplateEdit from '@/pages/templates/TemplateEdit'
import TemplateList from '@/pages/templates/TemplateList'

import ProductTypeList from '@/pages/product-types/ProductTypeList'
import ProductTypeEdit from '@/pages/product-types/ProductTypeEdit'
import ProductTypeAdd from '@/pages/product-types/ProductTypeAdd'

import ProductTagList from '@/pages/product-tags/ProductTagList'
import ProductTagEdit from '@/pages/product-tags/ProductTagEdit'
import ProductTagAdd from '@/pages/product-tags/ProductTagAdd'

import ShippingMethodList from '@/pages/shipping-methods/ShippingMethodList'
import ShippingMethodEdit from '@/pages/shipping-methods/ShippingMethodEdit'
import ShippingMethodAdd from '@/pages/shipping-methods/ShippingMethodAdd'

import TemplateCategoryList from '@/pages/template-categories/TemplateCategoryList'
import TemplateCategoryAdd from '@/pages/template-categories/TemplateCategoryAdd'
import TemplateCategoryEdit from '@/pages/template-categories/TemplateCategoryEdit'

import PaymentMethodList from '@/pages/payment-methods/PaymentMethodList'

import ProductCatalogue from '@/pages/reps/ProductCatalogue'
import QuoteList from '@/pages/reps/QuoteList'

import CategoryGroupList from '@/pages/product-category-groups/CategoryGroupList'
import CategoryGroupEdit from '@/pages/product-category-groups/CategoryGroupEdit'
import CategoryGroupAdd from '@/pages/product-category-groups/CategoryGroupAdd'

import UserAccessList from '@/pages/user-access/UserAccessList'
import UserAccessEdit from '@/pages/user-access/UserAccessEdit'
import UserAccessAdd from '@/pages/user-access/UserAccessAdd'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: LoginPage
    },

    {
      path: '/',
      name: 'DashboardPage',
      component: DashboardPage
    },

    {
      path: '/products',
      name: 'ProductList',
      component: ProductList
    },
    {
      path: '/products/edit/:id',
      name: 'ProductEdit',
      component: ProductEdit
    },  
    {
      path: '/product/add',
      name: 'ProductAdd',
      component: ProductAdd
    }, 

    {
      path: '/orders',
      name: 'OrderList',
      component: OrderList
    },
    {
      path: '/orders/edit/:id',
      name: 'OrderEdit',
      component: OrderEdit
    },    
    {
      path: '/orders/:id',
      name: 'OrderView',
      component: OrderView
    },  

    {
      path: '/print-type',
      name: 'PrintTypeList',
      component: PrintTypeList
    },
    {
      path: '/print-type/edit/:id',
      name: 'PrintTypeEdit',
      component: PrintTypeEdit
    },  
    {
      path: '/print-type/add',
      name: 'PrintTypeAdd',
      component: PrintTypeAdd
    }, 

    {
      path: '/corporation',
      name: 'CorporationList',
      component: CorporationList
    },
    {
      path: '/corporation/edit/:id',
      name: 'CorporationEdit',
      component: CorporationEdit
    },  
    {
      path: '/corporation/add',
      name: 'CorporationAdd',
      component: CorporationAdd
    },

    {
      path: '/suppliers',
      name: 'SupplierList',
      component: SupplierList
    }, 
    {
      path: '/suppliers/edit/:id',
      name: 'SupplierEdit',
      component: SupplierEdit
    }, 
    {
      path: '/suppliers/add',
      name: 'SupplierAdd',
      component: SupplierAdd
    }, 

    {
      path: '/taxes',
      name: 'TaxList',
      component: TaxList
    }, 
    {
      path: '/taxes/edit/:id',
      name: 'taxEdit',
      component: TaxEdit
    }, 
    {
      path: '/taxes/add',
      name: 'TaxAdd',
      component: TaxAdd
    }, 

    {
      path: '/product-categories/add',
      name: 'CategoryAdd',
      component: ProductCategoryAdd
    }, 
     {
      path: '/product-categories/edit/:id',
      name: 'ProductCategoryEdit',
      component: ProductCategoryEdit
    }, 
     {
      path: '/product-categories',
      name: 'ProductCategoryList',
      component: ProductCategoryList
    }, 

    {
      path: '/users',
      name: 'UserList',
      component: UserList
    }, 
    {
      path: '/users/edit/:id',
      name: 'UserEdit',
      component: UserEdit
    }, 
    {
      path: '/users/add',
      name: 'UserAdd',
      component: UsersAdd
    }, 

    {
      path: '/templates',
      name: 'TemplateList',
      component: TemplateList
    }, 
    {
      path: '/template/edit/:id',
      name: 'TemplateEdit',
      component: TemplateEdit
    },    

    {
      path: '/product-types/add',
      name: 'ProductTypeAdd',
      component: ProductTypeAdd
    }, 
    {
      path: '/product-types/edit/:id',
      name: 'ProductTypeEdit',
      component: ProductTypeEdit
    }, 
    {
      path: '/product-types',
      name: 'ProductTypeList',
      component: ProductTypeList
    }, 

    {
      path: '/product-tag/add',
      name: 'ProductTagAdd',
      component: ProductTagAdd
    }, 
    {
      path: '/product-tag/edit/:id',
      name: 'ProductTagEdit',
      component: ProductTagEdit
    }, 

    {
      path: '/product-tags',
      name: 'ProductTagList',
      component: ProductTagList
    }, 
    {
      path: '/shipping-method/add',
      name: 'ShippingMethodAdd',
      component: ShippingMethodAdd
    }, 
    {
      path: '/shipping-method/edit/:id',
      name: 'ShippingMethodEdit',
      component: ShippingMethodEdit
    }, 

    {
      path: '/shipping-methods',
      name: 'ShippingMethodList',
      component: ShippingMethodList
    }, 

    {
      path: '/payment-methods',
      name: 'PaymentMethodList',
      component: PaymentMethodList
    }, 

    {
      path: '/template-category/add',
      name: 'TemplateCategoryAdd',
      component: TemplateCategoryAdd
    }, 
    {
      path: '/template-categories',
      name: 'TemplateCategoryList',
      component: TemplateCategoryList
    }, 
    {
      path: '/template-category/edit/:id',
      name: 'TemplateCategoryEdit',
      component: TemplateCategoryEdit
    }, 

    {
      path: '/reps/product-catalogue',
      name: 'ProductCatalogue',
      component: ProductCatalogue
    }, 

    {
      path: '/reps/quote-list',
      name: 'QuoteList',
      component: QuoteList
    }, 
    
    {
      path: '/product-category-group/add',
      name: 'CategoryGroupAdd',
      component: CategoryGroupAdd
    }, 
    {
      path: '/product-category-group',
      name: 'CategoryGroupList',
      component: CategoryGroupList
    }, 
    {
      path: '/product-category-group/edit/:id',
      name: 'CategoryGroupEdit',
      component: CategoryGroupEdit
    }, 

    {
      path: '/user-access/add',
      name: 'UserAccessAdd',
      component: UserAccessAdd
    }, 
    {
      path: '/user-access',
      name: 'UserAccessList',
      component: UserAccessList
    }, 
    {
      path: '/user-access/edit/:id',
      name: 'UserAccessEdit',
      component: UserAccessEdit
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js